// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './pages/m/rem.js';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

// import MetaInfo from 'vue-meta-info'
Vue.use(VueAwesomeSwiper)


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  // mounted () {
  //   document.dispatchEvent(new Event('render-event'))
  // }
})



// WEBPACK FOOTER //
// ./src/main.js